// import hooks
import { useMutation, UseMutationOptions } from 'react-query';

// import requests
import { requests } from 'RestAPIs/rapini';

// import types
import { CommandResultResponse } from 'generated/index';

/**
 *  NOTE: these wrappers are required because the original mutations createConfigurationPlanningEntityForAiBasicConfiguration and
 *  deleteConfigurationPlanningEntityForAiBasicConfiguration require a direct entityId argument at initialization
 *  but we want to use them in a dynamic way
 * */
export function useCreateConfigurationPlanningEntityDynamically(
  options?: UseMutationOptions<CommandResultResponse, Error, string>
) {
  return useMutation<CommandResultResponse, Error, string>(
    async (entityId: string) => {
      return requests.createConfigurationPlanningEntityForAiBasicConfiguration(
        entityId
      );
    },
    options
  );
}

export function useDeleteConfigurationPlanningEntityDynamically(
  options?: UseMutationOptions<CommandResultResponse, Error, string>
) {
  return useMutation<CommandResultResponse, Error, string>(
    async (entityId: string) => {
      return requests.deleteConfigurationPlanningEntityForAiBasicConfiguration(
        entityId
      );
    },
    options
  );
}
